import { Component, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ParseLinks, PaginationUtil, JhiLanguageService, AlertService, DateUtils } from 'ng-jhipster';

import { Lesson, LessonStatus, LessonService, LessonUtilService } from '.';
import { School, SchoolService } from '../../entities/school';
import { CityService } from '../../entities/city';
import { CountryService } from '../../entities/country';
import { ITEMS_PER_PAGE, DateUtilities } from '../../shared';
import { PaginationConfig } from '../../blocks/config/uib-pagination.config';
import { ClassType } from '../class-type/index';
import { AbstractGeograpicalDialogComponent } from '../../entities/abstract-dialog-component/abstract-geopraphical-dialog.component';
import { Principal, LoginModalService } from '../../shared';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-struct';
import opera = require('selenium-webdriver/opera');
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { TaxService } from '../tax';
import { StateStorageService } from '../../shared/auth/state-storage.service';

@Component({
    selector: 'jhi-lesson-no-auth',
    templateUrl: './lesson-no-auth.component.html'
})
export class LessonNoAuthComponent extends AbstractGeograpicalDialogComponent implements OnInit {
    public static readonly DAYS_TO_ADD = 60;
    public static readonly RESERVATION_STATUS_CANCELLED_AS_STRING: any = 'CANCELLED';
    public static readonly LESSON_BEGINING_FIELD_NAME = 'begining';
    public static readonly CARD_ENDING_FIELD_NAME = 'validUntil';
    public static readonly CARD_BEGINING_FIELD_NAME = 'validSince';

    availableLessonStatuses = [
        {id: LessonStatus.OPEN, value: 'OPEN'},
        {id: LessonStatus.EXECUTED, value: 'EXECUTED'},
        {id: LessonStatus.CANCELLED, value: 'CANCELLED'}
    ];

    classTypes: ClassType[];
    locations: Location[];
    lessons: Lesson[];
    private loadingLessons: boolean = false;
    schools: School[];
    private loadingSchools: boolean = false;
    error: any;
    success: any;
    searchQuery: string;
    fromDate: NgbDateStruct;
    toDate: NgbDateStruct;
    private cityId: number;
    classTypeId: number;
    schoolId: number;
    schoolIdPathParam: number;
    schoolName: string;
    schoolImageUrl: string;
    schoolLogoUrl: string;
    routeData: any;
    links: any;
    totalItems: any;
    queryCount: any;
    itemsPerPage: any;
    page: any;
    predicate: any;
    previousPage: any;
    reverse: any;
    modalRef: NgbModalRef;
    @ViewChild('searchForm') searchForm: NgForm;
    url: string;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private lessonService: LessonService,
        private parseLinks: ParseLinks,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private paginationUtil: PaginationUtil,
        private paginationConfig: PaginationConfig,
        private dateUtils: DateUtils,
        alertService: AlertService,
        schoolService: SchoolService,
        countryService: CountryService,
        cityService: CityService,
        taxService: TaxService,
        principal: Principal,
        private stateStorageService: StateStorageService,
        private loginModalService: LoginModalService
    ) {
        super(countryService, cityService, taxService, schoolService, alertService, principal);
        this.jhiLanguageService.setLocations(['lesson', 'lesson-public', 'lessonStatus']);
    }

    ngOnInit() {
        this.itemsPerPage = ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe((data) => {
            this.page = data['pagingParams'].page;
            this.previousPage = data['pagingParams'].page;
            this.reverse = data['pagingParams'].ascending;
            this.predicate = data['pagingParams'].predicate;
        });

        this.searchQuery = this.activatedRoute.snapshot.params['search']
            ? this.activatedRoute.snapshot.params['search']
            : '';

        this.schoolIdPathParam = this.activatedRoute.snapshot.params['schoolId'];

        // we have to set the values on the filters to reflect the current search if any
        if (this.searchQuery) {
                let snapshotParams = this.activatedRoute.snapshot.params;

                if (snapshotParams['yearFrom'] && snapshotParams['monthFrom'] && snapshotParams['dayFrom']) {
                    this.fromDate = {
                        year: parseInt(snapshotParams['yearFrom'], 10),
                        month:  parseInt(snapshotParams['monthFrom'], 10),
                        day:  parseInt(snapshotParams['dayFrom'], 10)
                    };
                }

                if (snapshotParams['yearTo'] && snapshotParams['monthTo'] && snapshotParams['dayTo']) {
                    this.toDate = {
                        year: parseInt(snapshotParams['yearTo'], 10),
                        month:  parseInt(snapshotParams['monthTo'], 10),
                        day:  parseInt(snapshotParams['dayTo'], 10)
                    };
                }
            this.classTypeId = snapshotParams['classType'];
            this.schoolId = snapshotParams['school'];
        }

        if (this.schoolIdPathParam) {
            // build the url for navigation to maintain the path with the school
            this.url = '/lesson-public/school/' + this.schoolIdPathParam;
            this.schoolService.searchNoAuth({
                query: 'id:' + this.schoolIdPathParam
            } )
            .subscribe(res => {
                let data: School[] = res.body;
                if (data && data.length === 1 ) {
                    this.schoolName = data[0].name;
                    this.schoolImageUrl = data[0].imageUrl;
                    this.schoolLogoUrl = data[0].logoUrl;
                }
            });
        } else {
            this.url = '/lesson-public';
            // we do not need the geographical locations if the school is given in the path
            this.loadGeographicalLocationsNoAuth(this.searchForm);
        }

        this.initSearchQuery();
        this.activatedRoute.params.subscribe((params) => {
            this.loadLessons();
        });
    }

    loadLessons() {
        if (!this.schoolId || !this.searchQuery) {
            return;
        }
        this.loadingLessons = true;
        this.lessonService.searchNoAuth({
            query: this.searchQuery,
            size: this.itemsPerPage,
            sort: this.sort(),
            page: this.page - 1,
        })
        .subscribe(
            (res: HttpResponse<Lesson[]>) => this.onLessonsSuccess(res.body, res.headers),
            (res: HttpErrorResponse) => this.onError(res)
        );
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }

    transition() {
        this.router.navigate([this.url], {
            queryParams:
            {
                page: this.page,
                size: this.itemsPerPage,
                search: this.searchQuery,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        });
        this.loadLessons();
    }

    clear() {
        this.lessons = null;
        this.page = 0;
        this.initSearchQuery();

        let params: any = {
            search: this.searchQuery,
            page: this.page,
            sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc'),
            classType : this.classTypeId,
            school : this.schoolId
        };

        if (this.fromDate) {
            params.yearFrom = this.fromDate.year;
            params.monthFrom = this.fromDate.month;
            params.dayFrom = this.fromDate.day;
        }

        if (this.toDate) {
            params.yearTo = this.toDate.year;
            params.monthTo = this.toDate.month;
            params.dayTo = this.toDate.day;
        }
        this.router.navigate([this.url, params]);
        this.loadLessons();
    }

    search() {
        this.page = 0;
        this.searchQuery = this.getLessonsQuery();

        let params: any = {
            search: this.searchQuery,
            page: this.page,
            sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc'),
            classType : this.classTypeId,
            school : this.schoolId
        };

        if (this.fromDate) {
            params.yearFrom = this.fromDate.year;
            params.monthFrom = this.fromDate.month;
            params.dayFrom = this.fromDate.day;
        }

        if (this.toDate) {
            params.yearTo = this.toDate.year;
            params.monthTo = this.toDate.month;
            params.dayTo = this.toDate.day;
        }
        this.router.navigate([this.url, params]);
    }

    trackId(index: number, item: Lesson) {
        return item.id;
    }

    sort() {
        let result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'begining') {
            result.push('begining');
        }
        return result;
    }

    // Init the values of the components and the search query
    private initSearchQuery() {
        // We only show the lessons from today to
        // a certain number of days DAYS_TO_ADD
        let fromDate = new Date();
        let toDate = new Date();
        toDate.setDate(fromDate.getDate() + LessonNoAuthComponent.DAYS_TO_ADD);

        let fromDateStruct: NgbDateStruct = {
            year: fromDate.getFullYear(),
            month : fromDate.getMonth() + 1,
            day : fromDate.getDate()
        };

        let toDateStruct: NgbDateStruct = {
            year: toDate.getFullYear(),
            month : toDate.getMonth() + 1,
            day : toDate.getDate()
        };

        this.classTypeId = null;
        this.schoolId = this.schoolIdPathParam ? this.schoolIdPathParam : null;
        this.fromDate = fromDateStruct;
        this.toDate = toDateStruct;
        this.searchQuery = this.getLessonsQuery();
    }

    loadSchoolsNoAuth(form: NgForm) {
        this.loadingSchools = true;
        this.schools = null;
        this.schoolService.searchNoAuth({
            query: 'city.id:' + this.cityId,
            size: this.itemsPerPage
        }).subscribe(
            (res: HttpResponse<School[]>) => {
                this.loadingSchools = false;
                this.schools = res.body;
                if (!this.schools || this.schools.length <= 0 ) {
                    this.schoolId = null;
                    this.schools = null;
                    return;
                }
                this.schools.sort((a: School, b: School) =>
                        a && a.name.localeCompare(b.name));
                form.controls['school'].setValue(this.schools[0].id);
            }, (res: HttpErrorResponse) => this.onError(res)
            );
        return;
    }

    getLabelForSmallDevices(value: string): string {
        return LessonUtilService.getLabelForSmallDevices(value);
    }

    dateFromChanged(event) {
        // There is no action to take when dateFrom changes
    }

    /**
     * Returns true if all validations to activate the search button pass.
     */
    isSearchActive() {
            return this.schoolId != null &&
                   DateUtilities.isDateRangeValid(this.fromDate, this.toDate, true);
    }

    getStyle(index: number): any {
        return  index === 0 ||
        !this.isTheSameDateAsPreviousLesson(index)
        ? {'border-top': '2px solid gray'} : '';
    }

    shouldPrintDate(index: number): boolean {
        return index === 0 || !this.isTheSameDateAsPreviousLesson(index);
    }

    login() {
        this.modalRef = this.loginModalService.open();
    }

    registerBookClicked(lesson: Lesson) {
        this.storeNextUrl(lesson);
        this.storeRegisteringSchool();

        this.modalRef = this.loginModalService.open();
    }

    registerViewClicked(lesson: Lesson) {
        this.storeNextUrl(lesson);
        this.storeRegisteringSchool();

        this.modalRef = this.loginModalService.open();
    }

    private storeRegisteringSchool(): void {
        // the user is seeing the lessons of a school using the public link of the school
        // or he has selected the school
        if (this.schoolIdPathParam) {
            this.stateStorageService.setRegisteringSchool(this.schoolIdPathParam);
        } else if (this.schoolId) {
            this.stateStorageService.setRegisteringSchool(this.schoolId);
        }
    }

    private storeNextUrl(lesson: Lesson): void {
        if (lesson) {
            this.stateStorageService.setPostLoginRedirectUrl( `/lesson/${lesson.id}`);
        }
    }

    private isTheSameDateAsPreviousLesson(index: number) {
        return this.lessons[index].begining.getDate() === this.lessons[index - 1].begining.getDate();
    }

    // returns the value of the query search using the components
    private getLessonsQuery(): string {
        let operators = [];

        if (this.schoolId) {
            operators.push('school.id:' + this.schoolId);
        }

        if (this.classTypeId) {
            operators.push('classType.id:' + this.classTypeId);
        }

        if (this.fromDate || this.toDate) {
            operators.push(DateUtilities.getDateRangeQuery(LessonNoAuthComponent.LESSON_BEGINING_FIELD_NAME,
                this.fromDate, this.toDate));
        }

        return operators.reduce((query, operator, i) => {
            query = query + operator + ((i < operators.length - 1) ? ' AND ' : '');
            return query;
        }, '');
    }

    private onLessonsSuccess(data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        // we do not want to show several the lessons in the public agenda
        this.totalItems = Math.min(headers.get('X-Total-Count'), this.itemsPerPage * 3);
        this.queryCount = this.totalItems;
        this.lessons = data;
        this.loadingLessons = false;
    }

    getLessonStyle(lesson: Lesson) {
        return  {'color': LessonUtilService.getBackgroundColor(lesson)};
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/lesson/lesson-no-auth.component.ts